var map = {
	"./PIPE-雨水.png": "5a3f",
	"./W-新建热力.png": "90e6",
	"./w-新建中水.png": "184e",
	"./w-新建供油.png": "180a",
	"./w-新建机场通信.png": "13e0",
	"./w-新建污水.png": "eb5f",
	"./w-新建电力.png": "681b",
	"./w-新建给水.png": "d220",
	"./燃气.png": "8aca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1bab";